import { FETCH_SYNC_META_REQUEST, FETCH_SYNC_META_SUCCESS, FETCH_SYNC_META_FAILURE, FETCH_SYNC_META_REST, } from "../../actions";
const initialState = {
    metaData: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SYNC_META_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, metaData: null, error: null });
        case FETCH_SYNC_META_SUCCESS:
            return Object.assign(Object.assign({}, state), { metaData: action.payload, isLoading: false, error: null });
        case FETCH_SYNC_META_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_SYNC_META_REST:
            return Object.assign(Object.assign({}, state), { metaData: null, isLoading: true, error: null });
        default:
            return state;
    }
};
export default reducer;
